import type { ICastingDirector } from '../types/global/helper';

/**
 * API / Mongo payloads sometimes use `id` instead of `_id`. The app and
 * `parseAuditionPayload` expect `_id` for production company selection.
 */
export function normalizeCastingDirectorRecord(raw: unknown): ICastingDirector | null {
    if (!raw || typeof raw !== 'object') return null;
    const r = raw as Record<string, unknown>;
    const rawId = r._id ?? r.id ?? r.documentId ?? r.document_id;
    if (rawId == null || String(rawId).trim() === '') return null;
    return { ...(r as object), _id: String(rawId) } as ICastingDirector;
}

export function normalizeCastingDirectorList(rawList: unknown): ICastingDirector[] {
    if (!Array.isArray(rawList)) return [];
    const out: ICastingDirector[] = [];
    for (const item of rawList) {
        const n = normalizeCastingDirectorRecord(item);
        if (n) out.push(n);
    }
    return out;
}
